import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc2f776"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "swapBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, "辅舒良作为二代鼻用激素具有良好的疗效及安全性", -1))
const _hoisted_5 = { class: "bakBox" }
const _hoisted_6 = { class: "reportText" }
const _hoisted_7 = { class: "boxTail" }
const _hoisted_8 = { class: "leftright" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createTextVNode(" 研究结果表明，与布地奈德相比，丙酸氟替卡松鼻喷雾剂在"),
        /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "减少喷嚏、鼻痒方面效果更为显著"),
        /*#__PURE__*/_createElementVNode("span", { class: "jiaobiao" }, "1")
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_10 = { class: "footBox" }
const _hoisted_11 = { class: "reportBox" }
const _hoisted_12 = { class: "reportText" }
const _hoisted_13 = { class: "boxTail" }
const _hoisted_14 = { class: "leftright" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createTextVNode(" 辅舒良不良反应发生率与安慰剂相似，整体 "),
        /*#__PURE__*/_createElementVNode("p", { class: "blue" }, "耐受性与安全性良好"),
        /*#__PURE__*/_createElementVNode("span", { class: "jiaobiaotwo" }, "2")
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_16 = { class: "footBox" }
const _hoisted_17 = { class: "reportBox" }
const _hoisted_18 = { class: "home" }
const _hoisted_19 = { class: "ip" }
const _hoisted_20 = { class: "pingzi" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_van_image, {
              width: "7.4rem",
              height: "2.3rem",
              src: require('../assets/bingsuan.png')
            }, null, 8, ["src"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_van_image, {
              width: "7.4rem",
              height: "2.3rem",
              src: require('../assets/suanfo.png')
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_van_image, {
            onClick: $options.nexStept,
            width: "5.64rem",
            height: "1.3333rem",
            src: require('../assets/button.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_van_image, {
            class: "finger",
            width: "2.1467rem",
            height: "2.6933rem",
            src: require('../assets/pingzi.png')
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: $data.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
    }, {
      default: _withCtx(() => [
        ($data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 0,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true),
        (!$data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 1,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_toNav, { menu: 4 })
  ], 64))
}